import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";
import { isManager, isManagerRestrictedRoute } from "../helpers/rbac_helper";

import { logoutUser } from "../slices/auth/login/thunk";

const AuthProtected = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { userProfile, loading, token } = useProfile();
  
  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!token && !loading) {
      // If no token and not loading, ensure logout and redirect
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  /*
    Navigate is un-auth access protected routes via url
    */

  // If still loading, don't render children yet
  if (loading) {
    return null;
  }

  // Redirect to login if no token exists after loading is complete
  if (!token) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: location } }} replace />
    );
  }

  // If no user profile but has token, still redirect (token might be invalid or corrupted)
  if (!userProfile) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: location } }} replace />
    );
  }

  if (isManager() && isManagerRestrictedRoute(location.pathname)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };